export default __webpack_public_path__ + "ef55421cc9ee29e9003744d03f748126.png";